module.exports = __webpack_public_path__ + "static/media/union.9f2d40f5.svg";